/**
 * Procurement source URL utilities.
 * Handles links that may open as downloads (common with procurement portals).
 */

/** Known portals that often return HTML as attachment or require special handling */
export const DOWNLOAD_PORTALS = [
  'ted.europa.eu',
  'sam.gov',
  'find-tender.service.gov.uk',
  'contracts.gov',
  'austender.gov.au',
];

/** Check if URL is from a known download-prone portal */
export function isDownloadPortal(url) {
  if (!url || typeof url !== 'string') return false;
  try {
    const host = new URL(url).hostname.toLowerCase();
    return DOWNLOAD_PORTALS.some((p) => host.includes(p));
  } catch {
    return false;
  }
}

/** Tooltip text for source links (Phase 1) */
export const SOURCE_LINK_TOOLTIP =
  'Some sources may download a file instead of opening in-browser.';
